import { useEffect, useState } from "preact/hooks";

// On phones the pill-anchored popovers (feedback list, profile) are rendered as
// full-height edge drawers instead. Tracks the breakpoint live so rotating the
// device switches layout.
const MOBILE_QUERY = "(max-width: 640px)";

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(MOBILE_QUERY).matches,
  );
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setMobile(mq.matches);
    onChange();
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  return mobile;
}
